import React from "react";
import _ from "lodash";
import NetworkInfoHeader from "components/ops-mgmt/common/NetworkInfoHeader";
import LoadingUI from "components/common/LoadingUI";
import ModalWrapper from "components/common/ModalWrapper";
import SimpleTooltip from "components/common/SimpleTooltip";
import PromptModal from "components/common/PromptModal";
import DateTimeTooltip from "components/common/DateTimeTooltip";
import StickyTableWrapper from "components/common/StickyTableWrapper";
import RefreshModal from "./RefreshModal";
import CreateModal from "./CreateModal";
import SharedModal from "./SharedModal";

import { CrossCheckSheetAPI, NetworkAPI } from "apis";
import {
  thClass,
  tdClass,
  buttonActionClassGray,
  buttonConfirmClass,
} from "helpers/StyleClass";
import { MESSAGE } from "constants/Message";
import { FiPlus, FiMinus, FiFileText, FiExternalLink } from "react-icons/fi";
import { ROLE, ACTION } from "./CrossCheckHelper";
import DateTimeFormatter from "components/common/DateTimeFormatter";

class CrossCheckView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      network: null,
      networkId: null,
      isLoading: false,

      action: null,
      role: null,

      isPromptModalOpen: false,
      isSaving: false,
      promptMsg: [],
      promptHeader: "",
      promptMessage: "",
      promptAction: null,

      data: [],
      expandList: [],
      selectedSheet: null,
      selectedInstance: null,
    };

    this.handleUpdateData = this.handleUpdateData.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
    this.handleExpand = this.handleExpand.bind(this);
    this.handleExpandAll = this.handleExpandAll.bind(this);
  }

  async componentDidMount() {
    this.setState({ isLoading: true });
    const networkId = _.get(this.props, "match.params.networkId");

    if (networkId) {
      const networkInfo = await NetworkAPI.getNetworkInfo({
        networkId,
      });
      if (networkInfo) {
        this.setState({ networkId, network: networkInfo }, () => {
          this.handleUpdateData();
        });
      }
    }
  }

  async handleUpdateData() {
    const { networkId, data, expandList } = this.state;
    this.setState({ isLoading: true });
    const result = await CrossCheckSheetAPI.getCrossCheckSheets({
      networkId,
    });
    this.setState({
      networkId,
      data: result,
      expandList: data.length === 0 ? result.map((d) => d.id) : expandList,
      isLoading: false,
    });
  }

  async handleDelete(isPrompt = true) {
    const { selectedSheet, selectedInstance, role, networkId } = this.state;
    if (isPrompt) {
      this.setState({
        isPromptModalOpen: true,
        promptHeader: `Delete ${role}`,
        promptMsg: [],
        promptMessage: (
          <>
            Are you sure you want to delete the {role.toLowerCase()}?
            <div className="font-semibold text-red-600">
              {role === ROLE.CCS
                ? `${selectedSheet.id} ${selectedSheet.name}`
                : `${selectedInstance.id} ${selectedInstance.name}`}
            </div>
          </>
        ),
        promptAction: () => {
          this.handleDelete(false);
        },
      });

      return;
    }

    this.setState({ isSaving: true, promptMsg: [] });
    try {
      if (role === ROLE.CCS) {
        const { opOK } = await CrossCheckSheetAPI.deleteCrossCheckSheet({
          networkId,
          sheetId: selectedSheet.id,
        });

        if (opOK) {
          this.setState({
            isSaving: false,
            promptMsg: [
              "Cross check sheet deleted successfully",
              MESSAGE.SUCCESS,
            ],
          });
        }
      } else if (role === ROLE.INSTANCE && selectedInstance) {
        const { opOK } = await CrossCheckSheetAPI.deleteCcsInstance({
          networkId,
          sheetId: selectedSheet.id,
          instanceId: selectedInstance.id,
        });

        if (opOK) {
          this.setState({
            isSaving: false,
            promptMsg: ["Google sheet deleted successfully", MESSAGE.SUCCESS],
          });
        }
      }
    } catch (err) {
      this.setState({
        isSaving: false,
        promptMsg: [
          err.message || `Failed to delete ${role.toLowerCase()}.`,
          MESSAGE.ERROR,
        ],
      });
    }
  }

  handleExpandAll(flag) {
    const { data } = this.state;
    this.setState({
      expandList: flag ? data.map((d) => d.id) : [],
    });
  }

  handleExpand(id) {
    const { expandList } = this.state;
    this.setState({
      expandList: expandList.includes(id)
        ? expandList.filter((item) => item !== id)
        : [...expandList, id],
    });
  }

  getGoogleSheetLink(sheetId) {
    return `https://docs.google.com/spreadsheets/d/${sheetId}`;
  }

  getGamConsoleLink(reportId, networkCode) {
    return `https://admanager.google.com/${networkCode}#reports/interactive/detail/report_id=${reportId}`;
  }

  render() {
    const {
      network,
      networkId,
      data,
      isLoading,

      role,
      action,

      selectedSheet,
      selectedInstance,
      expandList,

      isPromptModalOpen,
      isSaving,
      promptMsg,
      promptHeader,
      promptMessage,
      promptAction,
    } = this.state;

    return (
      <>
        <BaseHeader title="Cross Check Sheet"></BaseHeader>
        {network && (
          <NetworkInfoHeader networkInfo={network}></NetworkInfoHeader>
        )}
        {isLoading && (
          <div
            className="absolute left-0 top-0 flex h-screen w-screen items-center justify-center bg-gray-800 opacity-25"
            style={{ zIndex: 101 }}
          >
            <LoadingUI iconOnly={true}></LoadingUI>
          </div>
        )}
        <div
          className="bg-white px-12 py-6"
          style={{ height: "calc(100vh - 5.3rem)" }}
        >
          <div className="flex items-center justify-end">
            <button
              type="button"
              className={buttonConfirmClass}
              onClick={() =>
                this.setState({
                  action: ACTION.CREATE,
                  role: ROLE.CCS,
                })
              }
            >
              Create Cross Check Sheet
            </button>
          </div>
          <StickyTableWrapper maxHeight="calc(100% - 4rem)">
            <table className="shadow divide-y table w-full table-auto text-sm">
              <thead className="">
                <tr>
                  <th className={thClass + " w-12 bg-blue-100"}>
                    <button
                      type="button"
                      className="flex items-center justify-center text-blue-600 hover:text-blue-800"
                      onClick={() => {
                        this.handleExpandAll(
                          _.uniq(
                            expandList,
                            data.map((d) => d.id)
                          ).length === 0
                        );
                      }}
                    >
                      {_.uniq(
                        expandList,
                        data.map((d) => d.id)
                      ).length > 0 ? (
                        <FiMinus></FiMinus>
                      ) : (
                        <FiPlus></FiPlus>
                      )}
                    </button>
                  </th>
                  <th className={thClass + " w-16 bg-blue-100"}>Id</th>
                  <th className={thClass + " bg-blue-100"} colSpan="2">
                    Name
                  </th>
                  <th className={thClass + " bg-blue-100"}>Emails</th>
                  <th className={thClass + " bg-blue-100"}></th>
                  <th
                    className={thClass + " bg-blue-100 text-right"}
                    style={{ width: "20rem" }}
                  >
                    Action
                  </th>
                </tr>
              </thead>
              <tbody className="bg-gray-200">
                {_.orderBy(data, "id", "desc").map((item) => (
                  <React.Fragment key={item.id}>
                    <tr>
                      <td className={tdClass}>
                        <button
                          type="button"
                          className="flex items-center justify-center text-sm text-blue-600 hover:text-blue-800"
                          onClick={() => {
                            this.handleExpand(item.id);
                          }}
                        >
                          {expandList.includes(item.id) ? (
                            <FiMinus></FiMinus>
                          ) : (
                            <FiPlus></FiPlus>
                          )}
                        </button>
                      </td>
                      <td className={tdClass}>{item.id}</td>
                      <td className={tdClass} colSpan="2">
                        <div className="flex items-center gap-2">
                          <div className="mr-auto break-all font-semibold">
                            {item.name}
                          </div>
                          <SimpleTooltip
                            tooltipText="View Sheet Setting"
                            place="right"
                          >
                            <div
                              className="flex cursor-pointer items-center justify-center text-lg text-blue-600 hover:text-blue-800"
                              onClick={() => {
                                this.setState({
                                  action: ACTION.VIEW,
                                  selectedSheet: item,
                                });
                              }}
                            >
                              <FiFileText></FiFileText>
                            </div>
                          </SimpleTooltip>
                        </div>
                        <div className="text-xs">
                          <div className="flex items-center gap-4">
                            <SimpleTooltip
                              tooltipText={`Open Google Sheet: ...${item.google_spreadsheet_id.slice(
                                -5
                              )}`}
                              place="bottom"
                            >
                              <div
                                className="flex cursor-pointer items-center justify-center text-sm font-semibold text-blue-600 hover:text-blue-800"
                                onClick={() => {
                                  window.open(
                                    this.getGoogleSheetLink(
                                      item.google_spreadsheet_id
                                    ),
                                    "_blank"
                                  );
                                }}
                              >
                                Spreadsheet
                                <span className="ml-1">
                                  <FiExternalLink></FiExternalLink>
                                </span>
                              </div>
                            </SimpleTooltip>
                            <SimpleTooltip
                              tooltipText={`Open Template Google Sheet: ...${item.template_google_spreadsheet_id.slice(
                                -5
                              )}`}
                              place="bottom"
                            >
                              <div
                                className="flex cursor-pointer items-center justify-center gap-1 text-sm font-semibold text-blue-600 hover:text-blue-800"
                                onClick={() => {
                                  window.open(
                                    this.getGoogleSheetLink(
                                      item.template_google_spreadsheet_id
                                    ),
                                    "_blank"
                                  );
                                }}
                              >
                                Template
                                <span className="ml-1">
                                  <FiExternalLink></FiExternalLink>
                                </span>
                              </div>
                            </SimpleTooltip>
                          </div>
                          <div className="text-gray-800">Reports:</div>
                          <div className="flex items-center gap-1">
                            {item.interactive_report_ids.map((id) => (
                              <SimpleTooltip
                                tooltipText="Open GAM Console"
                                key={id}
                              >
                                <div
                                  className="cursor-pointer bg-gray-400 px-1 text-center text-blue-800 hover:underline"
                                  key={id}
                                  onClick={() => {
                                    window.open(
                                      this.getGamConsoleLink(id, network.code),
                                      "_blank"
                                    );
                                  }}
                                >
                                  {id}
                                </div>
                              </SimpleTooltip>
                            ))}
                          </div>
                        </div>
                      </td>
                      <td className={tdClass + " break-all text-xs"}>
                        <span className="font-semibold">
                          Shared GAM Accounts:
                        </span>
                        {item.shared_emails.map((d) => (
                          <div key={d}>{d}</div>
                        ))}
                      </td>
                      <td className={tdClass}>
                        <div className="flex items-center gap-2 text-xs">
                          <div>
                            <DateTimeTooltip
                              data={[
                                {
                                  label: "Created At",
                                  value: item.created_at,
                                },
                                {
                                  label: "Updated At",
                                  value: item.updated_at,
                                },
                              ]}
                            ></DateTimeTooltip>
                          </div>
                          <div>
                            Created{" "}
                            <DateTimeFormatter
                              datetime={item.created_at}
                              fromNowOnly={true}
                            ></DateTimeFormatter>
                            <br></br>
                            Updated{" "}
                            <DateTimeFormatter
                              datetime={item.updated_at}
                              fromNowOnly={true}
                            ></DateTimeFormatter>
                          </div>
                        </div>
                      </td>
                      <td className={tdClass}>
                        <div className="mb-2 flex flex-wrap items-center justify-end gap-2">
                          <button
                            type="button"
                            className={buttonActionClassGray}
                            onClick={() => {
                              this.setState({
                                action: ACTION.REFRESH,
                                role: ROLE.CCS,
                                selectedSheet: item,
                              });
                            }}
                          >
                            Refresh
                          </button>
                          <button
                            type="button"
                            className={buttonActionClassGray}
                            onClick={() => {
                              this.setState({
                                action: ACTION.SHARE,
                                role: ROLE.CCS,
                                selectedSheet: item,
                              });
                            }}
                          >
                            Share GAM Account
                          </button>
                          <button
                            type="button"
                            className={buttonActionClassGray}
                            onClick={() => {
                              this.setState(
                                {
                                  selectedSheet: item,
                                  role: ROLE.CCS,
                                  action: ACTION.DELETE,
                                },
                                () => this.handleDelete()
                              );
                            }}
                          >
                            Delete
                          </button>
                        </div>
                        <div className="flex items-center justify-end">
                          <button
                            type="button"
                            className={buttonActionClassGray}
                            onClick={() => {
                              this.setState({
                                action: ACTION.CREATE,
                                role: ROLE.INSTANCE,
                                selectedSheet: item,
                              });
                            }}
                          >
                            Create Google Sheet
                          </button>
                        </div>
                      </td>
                    </tr>
                    {expandList.includes(item.id) &&
                      item.instances.map((instance) => (
                        <tr key={instance.id} className="bg-gray-100">
                          <td className={tdClass}></td>
                          <td className={tdClass} colSpan="3">
                            <div className="">
                              <div className="font-semibold text-gray-800">
                                [{instance.id}] {instance.name}
                              </div>
                              <div>
                                <SimpleTooltip tooltipText="Open Google Sheet">
                                  <div
                                    className="flex cursor-pointer items-center justify-center text-xs font-bold text-blue-600 hover:text-blue-800"
                                    onClick={() => {
                                      window.open(
                                        this.getGoogleSheetLink(
                                          instance.google_spreadsheet_id
                                        ),
                                        "_blank"
                                      );
                                    }}
                                  >
                                    Spreadsheet{" "}
                                    <span className="ml-1">
                                      <FiExternalLink></FiExternalLink>
                                    </span>
                                  </div>
                                </SimpleTooltip>
                              </div>

                              {/* <div className="w-1/2">
                             
                            </div> */}
                            </div>
                          </td>
                          <td className={tdClass}>
                            {instance.shared_emails &&
                              instance.shared_emails.length > 0 && (
                                <div className="text-xs">
                                  {instance.shared_emails.map((d) => (
                                    <div key={d}>{d}</div>
                                  ))}
                                </div>
                              )}
                          </td>
                          <td className={tdClass}>
                            <div className="flex items-center gap-2 text-xs">
                              <div>
                                <DateTimeTooltip
                                  data={[
                                    {
                                      label: "Created At",
                                      value: instance.created_at,
                                    },
                                    {
                                      label: "Updated At",
                                      value: instance.updated_at,
                                    },
                                  ]}
                                ></DateTimeTooltip>
                              </div>
                              <div>
                                Created{" "}
                                <DateTimeFormatter
                                  datetime={instance.created_at}
                                  fromNowOnly={true}
                                ></DateTimeFormatter>
                                <br></br>
                                Updated{" "}
                                <DateTimeFormatter
                                  datetime={instance.updated_at}
                                  fromNowOnly={true}
                                ></DateTimeFormatter>
                              </div>
                            </div>
                          </td>

                          <td className={tdClass}>
                            <div className="flex flex-wrap items-center justify-end gap-2">
                              <button
                                type="button"
                                className={buttonActionClassGray}
                                onClick={() => {
                                  this.setState({
                                    action: ACTION.REFRESH,
                                    role: ROLE.INSTANCE,
                                    selectedSheet: item,
                                    selectedInstance: instance,
                                  });
                                }}
                              >
                                Refresh
                              </button>
                              <button
                                type="button"
                                className={buttonActionClassGray}
                                onClick={() => {
                                  this.setState({
                                    action: ACTION.SHARE,
                                    role: ROLE.INSTANCE,
                                    selectedSheet: item,
                                    selectedInstance: instance,
                                  });
                                }}
                              >
                                Share email
                              </button>
                              <button
                                type="button"
                                className={buttonActionClassGray}
                                onClick={() => {
                                  this.setState(
                                    {
                                      action: ACTION.DELETE,
                                      role: ROLE.INSTANCE,
                                      selectedSheet: item,
                                      selectedInstance: instance,
                                    },
                                    () => this.handleDelete()
                                  );
                                }}
                              >
                                Delete
                              </button>
                            </div>
                          </td>
                        </tr>
                      ))}
                  </React.Fragment>
                ))}
              </tbody>
            </table>
          </StickyTableWrapper>
        </div>

        {action === ACTION.VIEW && selectedSheet && (
          <SettingViewModal
            setting={selectedSheet.setting}
            handleClose={() =>
              this.setState({ action: null, selectedSheet: null })
            }
            id={selectedSheet.id}
            name={selectedSheet.name}
          ></SettingViewModal>
        )}

        {action === ACTION.CREATE && (
          <CreateModal
            role={role}
            networkId={networkId}
            sheetId={selectedSheet ? selectedSheet.id : null}
            handleCancel={() => this.setState({ action: null })}
            handleClose={() => {
              this.handleUpdateData();
              this.setState({ action: null });
            }}
          ></CreateModal>
        )}

        {action === ACTION.REFRESH && (
          <RefreshModal
            role={role}
            sheetId={selectedSheet.id}
            instanceId={selectedInstance ? selectedInstance.id : null}
            networkId={networkId}
            handleClose={() => this.setState({ action: null })}
          ></RefreshModal>
        )}

        {action === ACTION.SHARE && (
          <SharedModal
            role={role}
            networkId={networkId}
            sheetId={selectedSheet.id}
            interactive={selectedSheet.interactive_report_ids.length > 0}
            instanceId={selectedInstance ? selectedInstance.id : null}
            content={
              role === ROLE.CCS
                ? selectedSheet.shared_emails.join(", ")
                : selectedInstance.shared_emails.join(", ")
            }
            handleClose={() => {
              this.handleUpdateData();
              this.setState({ action: null });
            }}
            handleCancel={() => this.setState({ action: null })}
          ></SharedModal>
        )}

        {isPromptModalOpen && (
          <PromptModal
            header={promptHeader}
            isOpenModal={isPromptModalOpen}
            handleConfirm={promptAction}
            handleCancel={() => this.setState({ isPromptModalOpen: false })}
            handleClose={() => {
              this.handleUpdateData();
              this.setState({ isPromptModalOpen: false });
            }}
            msg={promptMsg}
            isLoading={isSaving}
            width="35%"
          >
            {promptMessage}
          </PromptModal>
        )}
      </>
    );
  }
}

class SettingViewModal extends React.Component {
  render() {
    const { setting, handleClose, id, name } = this.props;

    return (
      <ModalWrapper
        isOpen={true}
        handleClose={handleClose}
        title={{
          label: "Cross Check Sheet Setting ",
          highlight: `${id} ${name}`,
        }}
        showCloseFooter={true}
        customOverlayStyle={{ zIndex: 100 }}
      >
        <div
          className="rounded overflow-y-auto bg-gray-100 p-4 text-sm"
          style={{ maxHeight: "60vh" }}
        >
          <pre>{JSON.stringify(setting, null, 2)}</pre>
        </div>
      </ModalWrapper>
    );
  }
}

const BaseHeader = ({ title }) => {
  return (
    <div className="border-b bg-gray-100 px-12 py-2">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-4">
          <div className="text-lg font-semibold text-gray-800">{title}</div>
        </div>
      </div>
    </div>
  );
};
export default CrossCheckView;
